import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { ssoApi } from '../services/api';

// Aterrizaje del SSO desde la Consola: /sso?token=<jwt corto>
// Canjea el token por una sesión de super-admin de SnelERP y entra a Super Admin.
export default function SsoLanding() {
  const { loginConSesion } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const hecho = useRef(false);

  useEffect(() => {
    if (hecho.current) return; // evita doble canje en StrictMode
    hecho.current = true;
    const token = new URLSearchParams(window.location.search).get('token');
    if (!token) { setError('Falta el token de acceso.'); return; }
    ssoApi(token)
      .then(({ data }) => { loginConSesion(data); navigate('/super-admin', { replace: true }); })
      .catch((e) => setError(e.response?.data?.error || 'No se pudo iniciar sesión por SSO.'));
    /* eslint-disable-next-line */
  }, []);

  return (
    <div style={s.wrap}>
      <style>{'@keyframes spin{to{transform:rotate(360deg)}}'}</style>
      <div style={s.card}>
        {error
          ? <>
              <div style={s.title}>No se pudo entrar</div>
              <p style={s.msg}>{error}</p>
              <a style={s.link} href="/login">Ir al inicio de sesión</a>
            </>
          : <>
              <div style={s.spin} />
              <div style={s.title}>Entrando a SnelERP…</div>
              <p style={s.msg}>Validando tu acceso desde la Consola.</p>
            </>}
      </div>
    </div>
  );
}

const s = {
  wrap: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#0f172a' },
  card: { background: '#1e293b', border: '1px solid #334155', borderRadius: 14, padding: '34px 40px', textAlign: 'center', color: '#cbd5e1', maxWidth: 380 },
  title: { color: '#f1f5f9', fontSize: 17, fontWeight: 700, margin: '14px 0 6px' },
  msg: { color: '#94a3b8', fontSize: 13, margin: 0 },
  link: { display: 'inline-block', marginTop: 14, color: '#60a5fa', fontSize: 13 },
  spin: { width: 34, height: 34, margin: '0 auto', border: '3px solid #334155', borderTopColor: '#3b82f6', borderRadius: '50%', animation: 'spin 0.8s linear infinite' },
};
